import Swal from "sweetalert2";
import {
  ADDCOMPANYINFORMATION,
  ADDCOMPANYPRODUCTS,
  GETAllCOMPANYPRODUCTS,
  GETCOMPANYENQUIRIES,
  GETCOMPANYINFORMATION,
  GETCOMPANYPRODUCTS,
  GETINSTITUTE,
  INTERESTEDCOMPANYENQUIRIES,
  UPDATECOMPANYINFORMATION,
  UPDATECOMPANYPRODUCTS,
} from "../../utils/api";
import axios from "../../utils/axios";
import { swalAlertPopProps } from "../../utils/commonUtils";

export const getCompany = async (payload, callback) => {
  await axios
    .post(GETCOMPANYINFORMATION, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};

export const companyUpdate = async (payload, callback) => {
  await axios
    .post(UPDATECOMPANYINFORMATION, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully updated",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const companyAdd = async (payload, callback) => {
  await axios
    .post(ADDCOMPANYINFORMATION, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully Added",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getCompanypRODUCTS = async (payload, callback) => {
  await axios
    .post(GETCOMPANYPRODUCTS, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};

export const getAllCompanypRODUCTS = async (payload, callback) => {
  await axios
    .post(GETAllCOMPANYPRODUCTS, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};

export const productAdd = async (payload, callback) => {
  await axios
    .post(ADDCOMPANYPRODUCTS, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully Added",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const productUpdate = async (payload, callback) => {
  await axios
    .post(UPDATECOMPANYPRODUCTS, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully updated",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getCompanyEnquiries = async (payload, callback) => {
  await axios
    .post(GETCOMPANYENQUIRIES, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};

export const interestedCompanyEnquiries = async (payload, callback) => {
  await axios
    .post(INTERESTEDCOMPANYENQUIRIES, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Thank you for showing interest",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "info",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};